import { Controller } from "@hotwired/stimulus"

// A lesson is one calendar day, so the form has a single date plus a start and
// an end time. When the user picks a start time, default the end time to one
// hour later — unless they've already set it.
export default class extends Controller {
  static targets = ["startsAtTime", "endsAtTime"]

  updateEndsAtTime() {
    if (this.startsAtTimeTarget.value && this.endsAtTimeTarget.value === "") {
      const [hours, minutes] = this.startsAtTimeTarget.value.split(":")
      const endHour = (parseInt(hours) + 1).toString().padStart(2, "0")
      this.endsAtTimeTarget.value = `${endHour}:${minutes}`
    }
  }
}
